// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qLmM","toggle":"styles_toggle__1vIex","preview":"styles_preview__Hy9c4"};